import { Table } from "antd";
// import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ToastContainer } from "react-toastify";
// import DeleteModal from "../../../components/modelpopup/DeleteModal";
import EmployeeLeaveModelPopup from "./EmployeeLeaveModelPopup";
import EmployeeWFHModelPopup from "./EmployeeWFHModelPopup";
import EmployeeVisitModelPopup from "./EmployeeVisitModelPopup";
import SearchBox from "../../../components/SearchBox";
import { getEmpData } from "../../Services/ApiCalling";
import moment from "moment";
import LeaveFilter from "./LeaveFilter";
import { tuple } from "yup";
import { useNavigate } from "react-router-dom";

export const EmployeeLeave = ({ empStatsData }) => {
  const date = new Date();
  let curr_date = date.toISOString();
  let first_date = new Date(date.getFullYear(), date.getMonth() - 1, 1);

  const [apptype, setApptype] = useState({ value: "LEAVE", label: "Leave" });
  const [appStatus, setAppStatus] = useState({
    value: "PENDING",
    label: "Pending",
  });
  const [fromDate, setFromDate] = useState(first_date.toISOString());
  const [toDate, setToDate] = useState(curr_date);

  // {console.log("empStatsDataempStatsData",empStatsData)}
  const [fieldInputs, setFieldInputs] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(null);
  const [pageSize, setPageSise] = useState(null);
  const [totalRecord, settotalRecord] = useState(null);
  const [totalPage, settotalPage] = useState(null);
  const [users, setUsers] = useState();

  const token = localStorage.getItem("LogIn_Token");

  // const empData = async (token, apptype, appStatus, fromDate, toDate) => {
  //   setIsLoading(true);
  //   const resp = await getEmpData(token, apptype, appStatus, fromDate, toDate);
  //   setUsers(resp.data);
  //   console.log("paggination", resp.data);
  //   setCurrentPage(resp?.pagination?.currentPage);
  //   setPageSise(resp?.pagination?.pageSize);
  //   settotalPage(resp?.pagination?.totalPages);
  //   settotalRecord(resp?.pagination?.totalRecords);
  //   setIsLoading(false);
  // };

  // useEffect(() => {
  //   empData(token, apptype, appStatus, fromDate, toDate);
  // }, [token, apptype, appStatus, fromDate, toDate]);

  // const ApiCall = async () => {
  //   try {
  //     await empData(
  //       token,
  //       { value: "LEAVE", label: "Leave" },
  //       { value: "PENDING", label: "Pending" },
  //       fromDate,
  //       toDate
  //     );
  //   } catch (error) {
  //     console.error("Error:", error);
  //   }
  // };

  // function mouseOver(event) {
  //   event.target.style.background = "#FF9F43";
  //   event.target.style.color = "white";
  // }
  // function mouseOut(event) {
  //   event.target.style.background = "white";
  //   event.target.style.color = "black";
  // }

  // const columns = [
  //   {
  //     title: "Request Type",
  //     dataIndex: "REQ_TYPE",
  //     render: (text) => <span>{text}</span>,
  //     sorter: (a, b) => a.REQ_TYPE.length - b.REQ_TYPE.length,
  //   },

  //   {
  //     title: "From",
  //     dataIndex: "REQ_FROM",
  //     render: (text) => <span>{moment(text).format("DD-MM-YYYY")}</span>,
  //     sorter: (a, b) => a.REQ_FROM.length - b.REQ_FROM.length,
  //   },
  //   {
  //     title: "To",
  //     dataIndex: "REQ_TO",
  //     render: (text) => <span>{moment(text).format("DD-MM-YYYY")}</span>,
  //     sorter: (a, b) => a.REQ_TO - b.REQ_TO,
  //   },

  //   {
  //     title: "No Of Days",
  //     dataIndex: "NO_DAYS",
  //     render: (text) => <span>{text}</span>,
  //     sorter: (a, b) => a.NO_DAYS.length - b.NO_DAYS.length,
  //   },

  //   {
  //     title: "Reason",
  //     dataIndex: "REASON",
  //     render: (text) => <span>{text}</span>,
  //     sorter: (a, b) => a.REASON.length - b.REASON.length,
  //   },
  //   {
  //     title: "Status",
  //     dataIndex: "REQ_STATUS",
  //     sorter: true,
  //     render: (text) => {
  //       let color;

  //       // Determine the color based on the status
  //       if (text === "PENDING") {
  //         color = "orange";
  //       } else if (text === "REJECT") {
  //         color = "red";
  //       } else {
  //         color = "green";
  //       }

  //       return <span style={{ color }}>{text}</span>;
  //     },
  //   },
  //   {
  //     title: "Remarks",
  //     dataIndex: "HEAD_REMARK",
  //     render: (text) => <span>{text}</span>,
  //     sorter: (a, b) => a.HEAD_REMARK.length - b.HEAD_REMARK.length,
  //   },
  // ];

  const leaveStats = [
    {
      id: 1,
      title: "Monthly Consumption Usage Profile",
    },
  ];
  const navigate = useNavigate();

  const handleNextStep = () => {
    navigate("/add-project"); // Navigate to another route on button click
  };

  ///////////////////////////SIMMER EFFECT CODE
  // const renderPlaceholder = () => (
  //   <>
  //     <p className="placeholder-glow">
  //       <span className="placeholder col-12" />
  //     </p>
  //     <p className="placeholder-wave mb-0">
  //       <span className="placeholder col-12" />
  //     </p>
  //   </>
  // );

  // const placeholderData = new Array(5).fill({});
  ///////////////////////////SIMMER EFFECT CODE

  return (
    <>
      <div className="page-wrapper">
        <div className="content container-fluid">
          <h3
            className="page-title text-center m-4"
            style={{
              fontSize: "47px",
              // color: "black",
              // marginBottom: "30px",
            }}
          >
            {"Welcome To Customer Segmentation"}
          </h3>
          <div className="row">
            <div className="col-md-6">
              <div
                style={{
                  // cursor: "pointer",
                  // width: "390px",
                  marginTop: "70px",

                  backgroundColor: "#f0f0f0", // Light background for contrast
                  borderRadius: "10px", // Rounded corners
                  padding: "20px", // Padding for inner spacing
                  boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)", // Shadow effect
                  height: "auto", // Adjust height automatically
                  position: "sticky", // Keeps it fixed during scrolling
                  top: "20px",
                  // marginLeft: "80px",
                  marginRight: "0px", // Spacing from the top
                }}
                onClick={() => console.log("clicked clicked...")}
              >
                <br />
                <h4 style={{ color: "darkblue" }}>
                  Monthly Consumption Usage Profile
                </h4>
                <p style={{ fontSize: "16px", color: "#333" }}></p>
                <p style={{ fontSize: "16px", color: "#333" }}>
                  1. Clustering based on total electricity usage across each
                  month.
                  <br />
                  2. Identifies long-term trends in customer consumption, such
                  as increasing, decreasing, or seasonal patterns over time.
                  <br />
                  3. Useful for understanding overall consumption behavior over
                  a period and detecting irregularities or changes in usage
                  patterns
                </p>
              </div>
            </div>

            <div className="col-md-6">
              <div className="" onClick={handleNextStep}>
                {leaveStats.map((stat, index) => (
                  <div
                    className=""
                    key={index}
                    style={{
                      cursor: "pointer",
                      marginTop: "90px",
                      height: "150px",
                      backgroundColor: "darkblue",
                      borderRadius: "10px",
                      boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                      textAlign: "center",
                      color: "white",

                      display: "flex", // Enable flexbox
                      flexDirection: "column", // Stack content vertically
                      justifyContent: "center", // Center content vertically
                      alignItems: "center", // Center content horizontally
                    }}
                  >
                    <div className="stats-info text-center">
                      <h6 style={{ fontSize: "27px", margin: 0 }}>
                        {stat.title}
                      </h6>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* </div> */}
    </>
  );
};

export default EmployeeLeave;
